<template>
  <div class="category-two-content">
    <div class="delivery-grid">
      <v-card class="delivery-card" elevation="1">
        <div class="card-header">
          <div class="icon-badge">
            <v-icon size="24" color="white">mdi-postage-stamp</v-icon>
          </div>
          <div>
            <h2>{{ t('rechnung.categoryTwo.postTitle') }}</h2>
            <p>{{ t('rechnung.categoryTwo.postSubtitle') }}</p>
          </div>
        </div>
        <div class="card-body">
          <div v-if="tarif" class="address-block" v-html="tarif.un_rechnung"></div>
          <p v-else class="placeholder-text">
            {{ t('rechnung.categoryTwo.loadingAddress') }}
          </p>

          <div class="card-links">
            <v-btn
              v-if="pdfUrlRechnung"
              :href="pdfUrlRechnung"
              target="_blank"
              color="#EA5545"
              variant="flat"
              prepend-icon="mdi-file-download"
            >
              {{ t('rechnung.categoryTwo.pdfRechnung') }}
            </v-btn>
          </div>
        </div>
      </v-card>

      <v-card class="delivery-card" elevation="1">
        <div class="card-header">
          <div class="icon-badge email">
            <v-icon size="24" color="white">mdi-email-fast</v-icon>
          </div>
          <div>
            <h2>{{ t('rechnung.categoryTwo.emailTitle') }}</h2>
            <p>{{ t('rechnung.categoryTwo.emailSubtitle') }}</p>
          </div>
        </div>

        <div class="card-body">
          <div class="mail-address" v-if="tarif">
            <v-icon size="18" color="#EA5545" class="mr-2">mdi-email-outline</v-icon>
            {{ tarif.un_rechnung_email }}
          </div>
          <p v-else class="placeholder-text">
            {{ t('rechnung.categoryTwo.loadingEmail') }}
          </p>

          <div class="card-links mail-links">
            <v-btn
              v-if="emailHrefRechnung"
              :href="emailHrefRechnung"
              color="#EA5545"
              variant="flat"
              prepend-icon="mdi-send"
            >
              {{ t('rechnung.categoryTwo.emailSendRechnung') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>

    <v-card class="tips-card" elevation="1">
      <div class="card-header tips-header">
        <div class="icon-badge tips">
          <v-icon size="24" color="white">mdi-lightbulb-on</v-icon>
        </div>
        <div>
          <h2>{{ t('rechnung.categoryTwo.tipsTitle') }}</h2>
          <p>{{ t('rechnung.categoryTwo.tipsSubtitle') }}</p>
        </div>
      </div>

      <ol class="tips-list">
        <li v-for="(tip, index) in t('rechnung.categoryTwo.tips')" :key="index">
          {{ t(`rechnung.categoryTwo.tips.${index}`, { projectName }) }}
        </li>
      </ol>
    </v-card>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'

/* global defineProps */

const { t } = useLanguage()

defineProps({
  tarif: {
    type: Object,
    default: null
  },
  pdfUrlRechnung: {
    type: String,
    default: null
  },
  emailHrefRechnung: {
    type: String,
    default: null
  },
  projectName: {
    type: String,
    default: 'Clearment'
  }
})
</script>

<style scoped src="@/assets/styles/sfc/components/objects/RechnungCategoryTwo.css"></style>

